import { render } from "./SortContextMenu.vue?vue&type=template&id=09af0860&ts=true"
import script from "./SortContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./SortContextMenu.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/core/report/components/SortContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09af0860"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09af0860', __exports__)) {
    console.log('reload')
    api.reload('09af0860', __exports__)
  }
  
  module.hot.accept("./SortContextMenu.vue?vue&type=template&id=09af0860&ts=true", () => {
    console.log('re-render')
    api.rerender('09af0860', render)
  })

}


export default __exports__